import { getActiveChainId, getRouterAddress } from '../config'
import { CDONT, CTOAST } from '../config/tokens'
import { JSBI, Percent } from '../sdk'

/** Clave estable para opciones de wallet (p. ej. modal pendiente). */
export type WalletOptionKey = 'METAMASK'

/**
 * Tokens y políticas de mercado: catálogo en `GET /v1/tokens/catalog`.
 * Contratos de protocolo: `src/config/chains/`.
 */
export { CDONT, CTOAST }

/** Router V2 de la cadena activa del build. Para otra cadena usar `getRouterAddress(chainId)`. */
export const ROUTER_ADDRESS = getRouterAddress(getActiveChainId())

export interface WalletInfo {
  /** Identificador estable para comparar con la vista pendiente / wagmi `injected`. */
  walletKey: WalletOptionKey
  name: string
  iconName: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  METAMASK: {
    walletKey: 'METAMASK',
    name: 'MetaMask',
    iconName: 'metamask.png',
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D',
  },
}

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 100
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%
